// extracted by mini-css-extract-plugin
export default {"input":"AddTransaction_input__nyQRw","form-select":"AddTransaction_form-select__SKZbw"};